import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const iconsSX: SxStyle = {
  color: '#FF9090',
};
